import { render, staticRenderFns } from "./PackageGuideDialog.vue?vue&type=template&id=2f7035e8&scoped=true"
import script from "./PackageGuideDialog.vue?vue&type=script&lang=js"
export * from "./PackageGuideDialog.vue?vue&type=script&lang=js"
import style0 from "./PackageGuideDialog.vue?vue&type=style&index=0&id=2f7035e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7035e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f7035e8')) {
      api.createRecord('2f7035e8', component.options)
    } else {
      api.reload('2f7035e8', component.options)
    }
    module.hot.accept("./PackageGuideDialog.vue?vue&type=template&id=2f7035e8&scoped=true", function () {
      api.rerender('2f7035e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/dialog/PackageGuideDialog.vue"
export default component.exports